<template>
  <div>
    <PageAllow controller="SubAccountAnalyses" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <!-- 批量分账 -->
            <v-btn
              v-if="$permission.permissionAllow('SubAccounts', 'batchSplit')"
              small
              color="accent"
              class="ms-1"
              @click.stop="
                showBatchSplit();
                dialog = true;
              "
            >
              <v-icon x-small class="pe-1">fa-money-check</v-icon>
              {{ $t("SubAccountAnalyses.batchSplit") }}
            </v-btn>
            <!-- 批量分账明细导出 -->
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'SubAccountAnalyses',
                  'exportForMaterial'
                )
              "
              small
              color="print"
              class="ms-1"
              dark
              @click.stop="batchExportSplitDetails()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("SubAccountAnalyses.batchExportSplitDetails") }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('SubAccounts', 'export')"
              small
              color="print"
              class="ms-1"
              dark
              @click.stop="exportExcel()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("Export.excel", [$t("Nav.subAccountAnalyses")]) }}
            </v-btn>
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'SubAccountAnalyses',
                  'billNoPayExport'
                )
              "
              small
              color="print"
              class="ms-1"
              dark
              @click.stop="billNoPayExport()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{
                $t("Export.export", [$t("SubAccountAnalyses.billNoPayExport")])
              }}
            </v-btn>
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'SubAccountAnalyses',
                  'billDetailExport'
                )
              "
              small
              color="print"
              class="ms-1"
              dark
              @click.stop="billDetailExport()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{
                $t("Export.export", [$t("SubAccountAnalyses.billDetailExport")])
              }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherSubAccount v-model="subAccountSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <SearcherSubAccountType v-model="options.sub_account_type" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.pay_flgs"
                  :label="$t('SubAccountAnalyses.payFlags')"
                  :items="payFlgsItems"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="settings && !settings.ws_sub_account_enable"
              >
                <SearcherStatus
                  v-model="options.order_status"
                  :label="$t('SubAccountAnalyses.orderStatus')"
                  :items="orderStatusItems"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.sub_account_status"
                  :label="$t('SubAccountAnalyses.subAccountStatus')"
                  :items="subAccountStatusItems"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="subAccountAnalyses"
          :options.sync="options"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td colspan="4">
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ totalBillFee | formatMoney }}</span
                >
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ totalReceiveMoney | formatMoney }}</span
                >
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ totalNoPayPrice | formatMoney }}</span
                >
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ totalSubAccountMoney | formatMoney }}</span
                >
              </td>
              <td align="center">
                <v-chip
                  small
                  label
                  :color="
                    totalReceiveMoney == totalSubAccountMoney
                      ? 'primary'
                      : 'error'
                  "
                  text-color="white"
                  >{{
                    totalReceiveMoney == totalSubAccountMoney
                      ? $t("SubAccountAnalyses.consistencyTRUE")
                      : $t("SubAccountAnalyses.consistencyFALSE")
                  }}
                </v-chip>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>{{ totalCount | formatNoDot }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>{{ totalShopCount | formatNoDot }}</span>
              </td>
              <td></td>
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("TableSum") }}
                </div>
                <div class="v-data-table__mobile-row__cell"></div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.TableHeaders.billFee") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }} {{ totalBillFee | formatMoney }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.TableHeaders.receiveMoney") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }} {{ totalReceiveMoney | formatMoney }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.TableHeaders.noPayPrice") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }} {{ totalNoPayPrice | formatMoney }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.TableHeaders.subAccountMoney") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}
                  {{ totalSubAccountMoney | formatMoney }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.TableHeaders.consistency") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  <v-chip
                    small
                    label
                    :color="
                      totalReceiveMoney == totalSubAccountMoney
                        ? 'primary'
                        : 'error'
                    "
                    text-color="white"
                    >{{
                      totalReceiveMoney == totalSubAccountMoney
                        ? $t("SubAccountAnalyses.consistencyTRUE")
                        : $t("SubAccountAnalyses.consistencyFALSE")
                    }}
                  </v-chip>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.TableHeaders.count") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ totalCount | formatNoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("SubAccountAnalyses.TableHeaders.shopCount") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ totalShopCount | formatNoDot }}
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:item.sub_account_type="{ item }">{{
            item.sub_account.sub_account_type +
            "-" +
            item.sub_account.sub_account_type_name
          }}</template>
          <template v-slot:item.bill_fee="{ item }">
            {{ $t("Global.money") }}
            {{ item.bill_fee | formatMoney }}
          </template>
          <template v-slot:item.receive_money="{ item }"
            >{{ $t("Global.money") }}
            {{ item.receive_money | formatMoney }}</template
          >
          <template v-slot:item.no_pay_price="{ item }">
            {{ $t("Global.money") }}
            {{ item.no_pay_price | formatMoney }}
          </template>
          <template v-slot:item.sub_account_money="{ item }"
            >{{ $t("Global.money") }}
            {{ item.sub_account_money | formatMoney }}</template
          >
          <template v-slot:item.consistency="{ item }">
            <v-chip
              small
              label
              :color="
                item.receive_money == item.sub_account_money
                  ? 'primary'
                  : 'error'
              "
              text-color="white"
              >{{
                item.receive_money == item.sub_account_money
                  ? $t("SubAccountAnalyses.consistencyTRUE")
                  : $t("SubAccountAnalyses.consistencyFALSE")
              }}</v-chip
            >
          </template>
          <template v-slot:item.count="{ item }">{{
            item.count | formatNoDot
          }}</template>
          <template v-slot:item.shop_count="{ item }">{{
            item.shop_count | formatNoDot
          }}</template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              small
              outlined
              color="info"
              class="px-2 me-2"
              :href="'/#/sub-account-analyses/' + item.sub_account_id"
            >
              <v-icon x-small class="pe-1">fa-align-left</v-icon>
              {{ $t("Opt.details") }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('SubAccounts', 'split')"
              small
              outlined
              color="accent"
              class="px-2 me-2"
              :href="'/#/sub-account-split/' + item.sub_account_id"
            >
              <v-icon x-small class="pe-1">fa-money-check</v-icon>
              <!-- 易生支付分账提现一步到位 -->
              {{
                "EXTYISHENG" == item.sub_account.bank_code
                  ? $t("SubAccountAnalyses.splitAndWithdraw")
                  : $t("SubAccountAnalyses.split")
              }}
            </v-btn>
          </template>
        </v-data-table>
      </div>

      <!-- 批量分账提示弹窗 -->
      <v-dialog v-model="dialog" max-width="360px">
        <v-card>
          <v-card-title @click="dialog = false">
            <span class="headline">{{
              $t("SubAccountAnalyses.batchSplit")
            }}</span>
            <v-spacer></v-spacer>
            <v-icon @click="dialog = false">fa-times</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="5" class="font-weight-bold text-right">{{
                  $t("SubAccountAnalyses.splitCount")
                }}</v-col>
                <v-col cols="7">
                  {{ total_count }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" class="font-weight-bold text-right">{{
                  $t("SubAccountAnalyses.splitTotal")
                }}</v-col>
                <v-col cols="7">
                  {{ $t("Global.money") }}
                  {{ total_receive_money | formatMoney }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              v-if="$permission.permissionAllow('SubAccounts', 'batchSplit')"
              color="accent"
              @click.stop="batchSplit()"
            >
              <v-icon x-small class="pe-1">fa-money-check</v-icon>
              {{ $t("SubAccountAnalyses.batchSplit") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherSubAccount from "@/components/plugins/SearcherSubAccount";
import SearcherSubAccountType from "@/components/plugins/SearcherSubAccountType";
import SubAccountAnalyses from "@/api/sub_account_analyses";
import SubAccounts from "@/api/sub_accounts";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";

const defaultOptions = {
  datetimeRadioSelected: "receive",
  receive_time_from:
    new Date(new Date().getTime() - 31 * 24 * 3600 * 1000) // 从昨天算起再往前三十天内
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  receive_time_to:
    new Date(new Date().getTime() - 1 * 24 * 3600 * 1000) // 截止昨天
      .toISOString()
      .substr(0, 10) + " 23:59:59",
  sub_account_time_from: "",
  sub_account_time_to: "",
  order_time_from: "",
  order_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  sub_account_id: 0,
  sub_account_type: [],
  sortBy: [],
  sortDesc: [],
  sub_account_status: [0, 2],
  pay_flgs: [3], //账单支付状态
  order_status: [6], //订单状态
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherSubAccount,
    SearcherSubAccountType,
    SearcherStatus,
    SearcherDatetimeRangeWithRadio,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.subAccountAnalyses"),
        disabled: true,
        href: "/sub-account-analyses",
      },
    ],
    headers: () => [
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.subAccountType"),
        align: "start",
        sortable: false,
        value: "sub_account_type",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.bank"),
        align: "start",
        sortable: false,
        value: "sub_account.bank_name",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.accountNumber"),
        align: "start",
        sortable: false,
        value: "account_number",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.accountName"),
        align: "start",
        sortable: false,
        value: "account_name",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.billFee"),
        align: "end",
        sortable: false,
        value: "bill_fee",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.receiveMoney"),
        align: "end",
        sortable: false,
        value: "receive_money",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.noPayPrice"),
        align: "end",
        sortable: false,
        value: "no_pay_price",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.subAccountMoney"),
        align: "end",
        sortable: false,
        value: "sub_account_money",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.consistency"),
        align: "center",
        sortable: false,
        value: "consistency",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.count"),
        align: "end",
        sortable: false,
        value: "count",
      },
      {
        text: i18n.t("SubAccountAnalyses.TableHeaders.shopCount"),
        align: "end",
        sortable: false,
        value: "shop_count",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    datetimeRadios: () => [
      {
        key: "receive",
        text: i18n.t("SubAccountAnalyses.receive_time"),
      },
      {
        key: "sub_account",
        text: i18n.t("SubAccountAnalyses.sub_account_time"),
      },
      {
        key: "order",
        text: i18n.t("SubAccountAnalyses.order_time"),
      },
      {
        key: "expect",
        text: i18n.t("SubAccountAnalyses.expect_date"),
      },
    ],
    payFlgsItems() {
      return this.$consts.subAccountAnalyses.pay_flgs;
    },
    orderStatusItems() {
      return this.$consts.subAccountAnalyses.status;
    },
    subAccountStatusItems() {
      return this.$consts.subAccountAnalyses.sub_account_status;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    // this.$store.commit("districtID", 0); // 本汇总中条目不体现地区，为避免误解每次进入页面重置为全部地区
    this.$store.commit("searchDistrict", false);
    this.$commonUtils
      .loadOptions("sub-account-analyses", ["subAccountSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "subAccountSelected":
                this.subAccountSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  data: () => ({
    subAccountSelected: null,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    subAccountAnalyses: [],
    totalBillFee: 0,
    totalReceiveMoney: 0,
    totalNoPayPrice: 0,
    totalSubAccountMoney: 0,
    totalCount: 0,
    totalShopCount: 0,
    dialog: false,
    total_receive_money: "",
    total_count: "",
  }),

  methods: {
    resetSearch() {
      this.subAccountSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.getSubAccountAnalysesFromAPI();
    },
    getSubAccountAnalysesFromAPI() {
      if (this.settings && this.settings.ws_sub_account_enable == 1) {
        delete this.options.order_status;
      }
      SubAccountAnalyses.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.subAccountAnalyses = response.data.sub_account_details;
            this.totalReceiveMoney = response.data.total_receive_money;
            this.totalBillFee = response.data.total_bill_fee;
            this.totalNoPayPrice = response.data.total_no_pay_price;
            this.totalSubAccountMoney = response.data.total_sub_account_money;
            this.totalCount = response.data.total_count;
            this.totalShopCount = response.data.total_shop_count;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    exportExcel() {
      if (this.settings && this.settings.ws_sub_account_enable == 1) {
        delete this.options.order_status;
      }
      SubAccountAnalyses.exports(this.options);
    },
    billNoPayExport() {
      if (this.settings && this.settings.ws_sub_account_enable == 1) {
        delete this.options.order_status;
      }
      SubAccountAnalyses.billNoPayExport(this.options);
    },
    billDetailExport() {
      if (this.settings && this.settings.ws_sub_account_enable == 1) {
        delete this.options.order_status;
      }
      SubAccountAnalyses.billDetailExport(this.options);
    },
    batchSplit() {
      //批量触发分账
      if (this.$store.fullscreenLoading) return; //防重复触发
      this.$store.dispatch("fullscreenLoading");
      this.dialog = false;
      if (this.settings && this.settings.ws_sub_account_enable == 1) {
        delete this.options.order_status;
      }
      SubAccounts.batchSplit(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("SubAccountAnalyses.splitQueued"));
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    // 批量分账展示
    showBatchSplit() {
      if (this.settings && this.settings.ws_sub_account_enable == 1) {
        delete this.options.order_status;
      }
      SubAccountAnalyses.fetch(
        Object.assign({}, this.options, {
          sub_account_status: 0,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.total_count = response.data.total_count;
            this.total_receive_money = response.data.total_receive_money;
          }
        }.bind(this)
      );
    },
    batchExportSplitDetails() {
      if (this.settings && this.settings.ws_sub_account_enable == 1) {
        delete this.options.order_status;
      }
      SubAccountAnalyses.batchExportDetail(this.options);
    },
  },

  watch: {
    // districtID: {
    //   handler() {
    //     this.getSubAccountAnalysesFromAPI();
    //   },
    // },
    settings: {
      handler() {
        if (this.settings && this.settings.ws_sub_account_enable == 1) {
          this.options = Object.assign({}, this.options, { order_status: [] });
        }
      },
    },
    subAccountSelected: {
      handler() {
        this.options.sub_account_id = this.subAccountSelected
          ? this.subAccountSelected.id
          : 0;
        sessionStorage.setItem(
          "sub-account-analyses-subAccountSelected",
          this.subAccountSelected
            ? JSON.stringify(this.subAccountSelected)
            : null
        );
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getSubAccountAnalysesFromAPI();
        sessionStorage.setItem(
          "sub-account-analyses-options",
          JSON.stringify(this.options)
        );
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>